<template>
  <div class="dk-login-card">
    <h1>DK商城</h1>
    <h2>密码登录</h2>
    <a-alert v-if="isLoginError" type="error" show-icon closable class="login-alert" :message="loginErrorInfo" :after-close="handleCloseLoginError" />
    <a-form-model ref="form" :model="form" :rules="rules" class="dk-login-form">
      <a-form-model-item prop="accountNo">
        <a-input v-model="form.accountNo" size="large" autocomplete="username" placeholder="请输入手机号或邮箱或工号" />
      </a-form-model-item>
      <a-form-model-item prop="password" class="password-field">
        <a-input-password v-model="form.password" size="large" autocomplete="current-password" placeholder="请输入密码" @pressEnter="handleSubmit" />
        <button type="button" class="forget-password" @click="showForgetPasswordTip">忘记密码 <a-icon type="question-circle" /></button>
      </a-form-model-item>
      <a-row v-if="captchaEnabled" :gutter="14" class="captcha-row">
        <a-col :span="16">
          <a-form-model-item prop="validCode">
            <a-input v-model="form.validCode" size="large" autocomplete="off" placeholder="请输入验证码" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <img class="captcha-image" :src="codeUrl" alt="验证码" @click="getCode">
        </a-col>
      </a-row>
      <a-button size="large" type="primary" html-type="submit" class="login-button" :loading="logining" :disabled="logining" @click="handleSubmit">登录</a-button>
    </a-form-model>
  </div>
</template>

<script>
import { getCodeImg } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'

export default {
  name: 'Login',
  data () {
    return {
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        accountNo: '',
        password: '',
        validCode: undefined,
        validCodeReqNo: '',
        rememberMe: true
      },
      rules: {
        accountNo: [{ required: true, message: '请输入手机号或邮箱或工号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        validCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      logining: false,
      captchaEnabled: false,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
    this.getStorage()
    this.getCode()
  },
  methods: {
    getCode () {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.validCodeReqNo = res.data.uuid
        }
      })
    },
    getStorage () {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      if (accountNo) {
        this.form.accountNo = accountNo
        this.form.password = password || ''
      }
    },
    showForgetPasswordTip () {
      this.$message.info('请联系管理员重置密码')
    },
    handleSubmit () {
      if (this.logining) return
      this.logining = true
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.logining = false
          return
        }
        storage.set(LOGIN_USERNAME, this.form.accountNo)
        storage.set(LOGIN_PASSWORD, this.form.password)
        storage.set(LOGIN_REMEMBERME, true)
        this.$store.dispatch('Login', this.form).then(() => {
          this.$router.push({ path: this.redirect || '/' }).catch(() => {})
        }).catch(err => {
          this.isLoginError = true
          this.loginErrorInfo = (err && err.message) || String(err || '登录失败，请重试')
          this.logining = false
          if (this.captchaEnabled) this.getCode()
        })
      })
    },
    handleCloseLoginError () {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.dk-login-card {
  width: 100%;
  max-width: 500px;
  padding: 48px 50px 60px;
  background: #fff;

  h1 {
    margin: 0 0 34px;
    color: #0a65e8;
    font-size: 32px;
    line-height: 1.4;
    font-weight: 700;
    letter-spacing: 2px;
  }

  h2 {
    margin: 0 0 22px;
    color: #333;
    font-size: 20px;
    line-height: 1.4;
    font-weight: 600;
  }
}

.login-alert {
  margin-bottom: 18px;
}

.dk-login-form {
  /deep/ .ant-form-item {
    margin-bottom: 20px;
  }

  /deep/ .ant-input {
    height: 46px;
    padding: 0 13px;
    background: #f9f9fa;
    border: 1px solid #dddce1;
    border-radius: 5px;
  }

  /deep/ .ant-input-password .ant-input {
    padding-right: 122px;
  }
}

.password-field {
  position: relative;
}

.forget-password {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 10px;
  height: 46px;
  padding: 0;
  border: 0;
  color: #999;
  font-size: 14px;
  background: transparent;
  cursor: pointer;
  outline: none;
}

.captcha-row .captcha-image {
  display: block;
  width: 100%;
  height: 46px;
  object-fit: cover;
  cursor: pointer;
}

.login-button {
  width: 100%;
  height: 46px;
  margin-top: 16px;
  border-color: #4981fa;
  border-radius: 4px;
  background: #4981fa;
  font-size: 16px;
}

@media (max-width: 560px) {
  .dk-login-card {
    padding: 28px 0 46px;
  }
}
</style>
